module.exports = __webpack_public_path__ + "static/media/instagram.2a0022c2.svg";